import { makeStyles } from "@material-ui/core";

export const useTransactionStyles = makeStyles((theme) => ({
  headerContainer: {
    background: "white",
  },
  headerTitle: {
    background: theme.palette.primary.main,
    color: "white",
    width: "100%",
  },
  dataContianer: {
    overflowY: "hidden",
  },
  itemContainer: {
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 10,
  },
  icon: {
    color: theme.palette.success.main,
  },
  priceTabProductTitle: {
    fontSize: 16,
    fontWeight: "bold",
  },
  transactiontitle: {
    fontSize: 18,
  },
  deleteFolioTitle: {
    color: theme.palette.grey[600],
    flexWrap: "nowrap",
  },
  nameItem: {
    color: theme.palette.grey[900],
    marginRight: 10,
    marginLeft: 10,
  },
}));
